import { Badge, BadgeColor } from '@gv/triage-components';

import { TaskTypeTitle } from 'types/data';

import { TaskVoicemailBadgeProps } from './types';

export const TaskVoicemailBadge = ({ type }: TaskVoicemailBadgeProps) => (
  <Badge text={TaskTypeTitle[type]} styleType={BadgeColor.SecondaryCerulean} />
);
